import { fetchData } from "./fetchData";

export const getSubchainsAPI = async(jobId) => {
    const route = `/subchains?jobid=${jobId}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

// create many subchains - expects array of subchains
export const createSubchainsAPI = async (subchainsData) => {
    const route = `/subchains`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({subchainsData})
    }

    let response = await fetchData(route, options);

    return response;
}

// update many subchains - expects array of subchains
export const updateSubchainsAPI = async (subchainsData) => {
    const route = `/subchains`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({subchainsData})
    }

    let response = await fetchData(route, options);

    return response;
}

// delete many subchains - expects array of subchains
export const deleteSubchainsAPI = async (subchainIds, JobID) => {
    const route = `/subchains`;

    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({subchainIds, JobID})
    }

    let response = await fetchData(route, options);

    return response;
}

// get the download link for SC template
export const getSCTemplateAPI = async() => {
    const route = `/subchains/template`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}